// extracted by mini-css-extract-plugin
export default {"sticker":"xYGYe","text":"msyY2"};